import { useQuery } from "@tanstack/react-query";
import { dubPartnersContract } from "@common/contracts/dub-partners.contract";
import {
    DubPartnersPublicTokenResponse,
    dubPartnersPublicTokenResponseSchema,
} from "@common/schemas/dub-partners.schema";
import { getBackendAPIClient } from "@lib/backendAPIClient";

const dubPartnersApiClient = getBackendAPIClient(dubPartnersContract);

async function getDubPartnersPublicToken(): Promise<DubPartnersPublicTokenResponse | null> {
    try {
        const response = await dubPartnersApiClient.getPublicToken();
        return dubPartnersPublicTokenResponseSchema.parse(response.body);
    } catch {
        return null;
    }
}

export function useDubPartnersPublicToken() {
    return useQuery({
        queryKey: ["dub-partners", "public-token"],
        queryFn: getDubPartnersPublicToken,
        staleTime: 1000 * 60 * 60 * 24,
    });
}
